import { createDraftSafeSelector } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { StrategyTemplateStateType } from "../reducer/strategyTemplates.reducer"

const state = (state: RootState) => state.strategyTemplateStore as StrategyTemplateStateType

export const selectStrategyTemplates = createDraftSafeSelector(state, (store) => store.strategies)
export const selectStrategyTemplate = (templateId: string) => createDraftSafeSelector(state, (store) => (store.strategies).find(s=>s.id===templateId))
export const selectStrategyTemplateOpen = createDraftSafeSelector(state, (store) => store.openDialog)
export const selectStrategyTemplateEditId = createDraftSafeSelector(state, (store) => store.editId)